module.exports = __webpack_public_path__ + "ingelavideo.jpg?4079b3bfab35999d99573694ed6b0648";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/ingelavideo.jpg
// module id = 1069
// module chunks = 0